module.exports = __webpack_public_path__ + "static/master.09526991.jpg";